import { useParams } from 'react-router-dom'
import ContentShell from '../../components/blog/ContentShell'
import Seo from '../../components/blog/Seo'
import Breadcrumbs from '../../components/blog/Breadcrumbs'
import PostCard from '../../components/blog/PostCard'
import NotFound from '../NotFound'
import { getCategory, getPostsByCategory } from '../../lib/blog/posts'
import { breadcrumbJsonLd } from '../../lib/seo'
import { describeCategory } from '../../data/blog/categoryMeta'

export default function BlogCategoryPage() {
  const { cat = '' } = useParams()
  const category = getCategory(cat)
  if (!category) return <NotFound />

  const posts = getPostsByCategory(category.slug)
  const description = describeCategory(category.slug, category.label)
  const path = `/blog/category/${category.slug}`

  return (
    <ContentShell>
      <Seo
        title={`${category.label} | BankStatementReader Blog`}
        description={description}
        canonicalPath={path}
        jsonLd={[
          breadcrumbJsonLd([
            { name: 'Home', path: '/' },
            { name: 'Blog', path: '/blog' },
            { name: category.label, path },
          ]),
        ]}
      />
      <div className="mx-auto max-w-5xl pt-6">
        <Breadcrumbs
          crumbs={[
            { name: 'Home', path: '/' },
            { name: 'Blog', path: '/blog' },
            { name: category.label, path },
          ]}
        />
        <h1 className="text-[clamp(2rem,3vw+1rem,2.8rem)] font-bold tracking-tight text-ink m-0">{category.label}</h1>
        <p className="text-ink-soft mt-3 mb-8">{description}</p>
        <div className="grid gap-6 md:grid-cols-3">
          {posts.map((p) => (
            <PostCard key={p.slug} post={p} />
          ))}
        </div>
      </div>
    </ContentShell>
  )
}
